import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=1c28b32d&scoped=true&"
import script from "./BrandPage.vue?vue&type=script&lang=js&"
export * from "./BrandPage.vue?vue&type=script&lang=js&"
import style0 from "./BrandPage.vue?vue&type=style&index=0&id=1c28b32d&lang=scss&scoped=true&"
import style1 from "./BrandPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28b32d",
  null
  
)

export default component.exports